import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "../../../text";
import { Tag } from "../../../tag";
import { NEW_RESIDENT } from "./types";
import { parseDate } from "./utils/helpers";
export const MatchedResidentInfo = ({ firstName, lastName, gender, dateOfBirth, similar_resident, matchedResident, }) => {
    return (_jsxs(_Fragment, { children: [_jsxs(Text, { children: [matchedResident?.resident?.first_name || firstName || "First name", ",", " ", matchedResident?.resident?.last_name || lastName || "last name", ",", " ", matchedResident?.resident?.gender || gender || "gender", ",", " ", dateOfBirth
                        ? parseDate(matchedResident?.resident?.date_of_birth || dateOfBirth, "date of birth")
                        : "date of birth"] }), " ", "\u00A0", _jsx(Tag, { color: "green100", children: similar_resident === NEW_RESIDENT ? "New" : "Linked" })] }));
};
